module.exports = __webpack_public_path__ + "static/media/map-marker.76735792.png";